// src/pages/ContinueInApp.js
// v3 – dual-path UX (phone vs computer)

import React from "react";
import { useLocation, Link } from "react-router-dom";
import QRCode from "react-qr-code";

import { ROUTES } from "../config";
import "../styles/ContinueInApp.css";

const EAS_INSTALL_URL =
  "https://expo.dev/accounts/limmy/projects/ghrianghraffy/builds/7a335c76-1a0e-4a73-bca8-3054b25842c0";

const ContinueInApp = () => {
  const location = useLocation();
  const emailFromState = location.state?.email || "";

  return (
    <div className="continue-in-app-page">
      <div className="continue-in-app-shell">
        {/* HERO */}
        <div className="continue-in-app-hero">
          <div className="continue-in-app-badge">Welcome</div>
          <h1 className="continue-in-app-title">Your account is ready</h1>

          <p className="continue-in-app-subtitle">
            How would you like to continue?
          </p>
        </div>

        {/* 🔥 NEW: CHOICE SECTION */}
        <div className="continue-choice-grid">
          {/* PHONE OPTION */}
          <div className="continue-choice-card">
            <div className="continue-choice-title">Use this phone</div>

            <p className="continue-choice-text">
              Continue setup on this device.
            </p>

            <a
              className="continue-in-app-button primary"
              href={EAS_INSTALL_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open / Install app
            </a>

            <p className="continue-choice-helper">
              If the app isn’t installed yet, you’ll be guided to install it.
            </p>
          </div>

          {/* COMPUTER OPTION */}
          <div className="continue-choice-card">
            <div className="continue-choice-title">Use your phone</div>

            <p className="continue-choice-text">
              Scan this with your phone camera to continue.
            </p>

            <div className="continue-in-app-qr-frame">
              <QRCode value={EAS_INSTALL_URL} size={150} />
            </div>

            <p className="continue-choice-helper">
              This opens the app install page on your phone.
            </p>
          </div>
        </div>

        {/* EXISTING GUIDANCE */}
        <section className="continue-in-app-card">
          <h2 className="continue-in-app-card-title">
            Use the same login details
          </h2>

          <div className="continue-in-app-credential-box">
            <div className="continue-in-app-credential-row">
              <div className="continue-in-app-credential-label">Email</div>
              <div className="continue-in-app-credential-value">
                {emailFromState || "Your registered email"}
              </div>
            </div>

            <div className="continue-in-app-credential-row">
              <div className="continue-in-app-credential-label">Password</div>
              <div className="continue-in-app-credential-value">
                The password you just created
              </div>
            </div>
          </div>

          <p className="continue-in-app-note">
            You’ll continue your school setup inside the app.
          </p>
        </section>

        {/* FOOTER */}
        <section className="continue-in-app-footer-card">
          <h2 className="continue-in-app-card-title">Need to come back later?</h2>

          <div className="continue-in-app-footer-actions">
            <a
              className="continue-in-app-button primary"
              href={EAS_INSTALL_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open install page
            </a>

            <Link
              className="continue-in-app-button secondary"
              to={ROUTES.LOGIN}
            >
              Back to Login
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ContinueInApp;